import { Box, Typography } from '@mui/material'
import { useParams } from 'react-router'

export default function AcceptInvitationPage() {
  const params = useParams<{ token: string }>()
  return (
    <Box display="flex" flexDirection="column" flex="1">
      <Typography variant="h1">Accept Invitation</Typography>
    </Box>
  )
}
